(() => {
  angular
    .module('gm.common.user.properties', [
      'angular-promise-cache'
    ])
    .factory('gmProperties', gmPropertiesFactory);

  function gmPropertiesFactory(
    $q,
    gmApi,
    promiseCache
  ) {
    'ngInject';

    return {
      createProperty,
      createOrUpdateProperty,
      getProperties,
      getProperty,
      removeProperty,
      updateProperties,
      updateProperty,
    };

    function createProperty(key, value) {
      return gmApi.post(
        'users/jsproperties',
        { key, value },
        { auth: true }
      );
    }

    function createOrUpdateProperty(key, value) {
      return getProperty(key)
        .then((prop) => {
          if (angular.isUndefined(prop)) {
            createProperty(key, value);
          } else {
            updateProperty(key, value);
          }
        });
    }

    function getProperties() {
      return promiseCache({
        promise: () => gmApi.get('users/jsproperties', { auth: true }).then(data => data.properties)
      });
    }

    function getProperty(name) {
      return getProperties().then(props => props[name]);
    }

    function removeProperty(key) {
      return gmApi.delete(`users/jsproperties/${key}`, { auth: true });
    }

    function updateProperties(properties) {
      return $q.all(Object.keys(properties)
        .map(key => createOrUpdateProperty(key, properties[key])));
    }

    function updateProperty(key, value) {
      return gmApi.put(
        `users/jsproperties/${key}`,
        { value },
        { auth: true }
      );
    }
  }
})();
